import { styled } from '@/styled-system/jsx';

export const ContactOverlayContainer = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    padding: '16px',
  },
});

export const ContactOverlayContent = styled('div', {
  base: {
    color: 'hpxBlue600',
    display: 'table-cell',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 'lg',
    width: '100%',
    paddingTop: '52px',
    verticalAlign: 'top',
    md: {
      paddingTop: '0',
      verticalAlign: 'middle',
    },
  },
});

export const ContactOverlayIncomeReq = styled('div', {
  base: {
    fontWeight: 'normal',
    fontSize: 'sm',
  },
});
